var map = {
	"./brainstorming": 21,
	"./brainstorming.svg": 21,
	"./cloud-bg": 22,
	"./cloud-bg.svg": 22,
	"./code_typing": 23,
	"./code_typing.svg": 23,
	"./compose_music": 24,
	"./compose_music.svg": 24,
	"./going_up": 25,
	"./going_up.svg": 25,
	"./idea": 26,
	"./idea.svg": 26,
	"./source_code": 27,
	"./source_code.svg": 27,
	"./speech_to_text": 28,
	"./speech_to_text.svg": 28,
	"./viedit_logo_black": 29,
	"./viedit_logo_black.svg": 29,
	"./vimeo_logo_blue": 30,
	"./vimeo_logo_blue.png": 30,
	"./youtube_logo_light": 31,
	"./youtube_logo_light.png": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;